export class SifreOlusturRequestModel {
    sifre:string
    sifreTekrarla:string
    googleCaptchaToken: string;
}
